import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-2 mb-xl-3" }
const _hoisted_2 = { class: "card-body pt-2 pb-0" }
const _hoisted_3 = { class: "overflow-auto" }
const _hoisted_4 = { class: "nav nav-line-tabs fs-6 fw-bolder" }
const _hoisted_5 = { class: "nav-item text-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Gas Prices ")
const _hoisted_7 = { class: "nav-item text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Gas Demand ")
const _hoisted_9 = { class: "nav-item text-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Electricity Prices ")
const _hoisted_11 = { class: "nav-item text-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Electricity Demand ")
const _hoisted_13 = { class: "nav-item text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" UK Electricity Generation ")
const _hoisted_15 = { class: "nav-item text-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Co2 Emission ")
const _hoisted_17 = { class: "nav-item text-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Exchange Rate ")
const _hoisted_19 = { class: "nav-item text-center" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Crude Oil ")
const _hoisted_21 = { class: "nav-item text-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Weather ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card mb-xl-3",
  id: "kt_profile_details_view"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer text-dark" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "m-5" }, " Our Market Insights allow you to visualise historic movements in supply, demand and price for a number of commodities including electricity, gas and oil. This is complemented by our market commentary which provides a greater level of understanding as to the key drivers which affect supply and demand fundamentals. Our data is updated on a weekly basis. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/GasPrices",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/GasDemand",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/ElectricityPrices",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/ElectricityDemand",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/UKElectricityGeneration",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/CO2Emmition",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/ExchangeRate",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/CrudeOil",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: "/MarketInsight/Weather",
                class: "nav-link text-active-primary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_23,
    _createVNode(_component_router_view)
  ], 64))
}